import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getAddressSuggestList: build.query({
      query: body => ({
        url: '/api/map/suggest',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useLazyGetAddressSuggestListQuery } = extendedApi
